var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0791 0C10.1163 0 10.1535 0 10.1929 0C10.2842 1.12835 9.85353 1.97146 9.3301 2.582C8.81651 3.18834 8.11322 3.7764 6.97574 3.68717C6.89986 2.57498 7.33125 1.79441 7.85397 1.18526C8.33875 0.617573 9.22753 0.112414 10.0791 0Z",
    fill: "#0F172A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5225 11.7443C13.5225 11.7556 13.5225 11.7654 13.5225 11.776C13.2028 12.7441 12.7468 13.5739 12.1904 14.3439C11.6824 15.043 11.0599 15.9837 9.94843 15.9837C8.988 15.9837 8.35005 15.3662 7.36573 15.3493C6.32449 15.3324 5.75188 15.8657 4.79988 15.9999C4.69098 15.9999 4.58208 15.9999 4.47529 15.9999C3.77621 15.8987 3.21203 15.3451 2.80102 14.8463C1.58906 13.3722 0.652513 11.4682 0.478271 9.03165C0.478271 8.79277 0.478271 8.55459 0.478271 8.31572C0.552043 6.5719 1.39936 5.15408 2.52561 4.46695C3.12 4.1016 3.9371 3.79036 4.84695 3.92947C5.23689 3.98989 5.63526 4.12338 5.98444 4.25547C6.31536 4.38264 6.72918 4.60817 7.12123 4.59622C7.3868 4.58849 7.65098 4.45009 7.91866 4.35243C8.70275 4.06928 9.47138 3.74469 10.4845 3.89715C11.7021 4.08123 12.5663 4.62222 13.1002 5.45689C12.0702 6.1124 11.2559 7.10024 11.3951 8.78715C11.5187 10.3195 12.4096 11.216 13.5225 11.7443Z",
    fill: "#0F172A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.c1ca61324306489aa6095b246a4f2c1a.svg";
export { ForwardRef as ReactComponent };